<script lang="ts">
    import { log } from "../../../api/hooks/lib/utils"
    import { apiBaseURL, baseURL } from "../config"

    export let contentId: string
    export let items: Facts[]
</script>

{#each items as item}
    <div class="item">
        {#if item.left || item.right}
            <div>{item.left}</div>
            <div>{item.right}</div>
        {/if}
        {#if item.text}
            {#if item.icon}
                <span class="icon"
                    ><img
                        src="{!item.icon?.src.startsWith('data:')
                            ? apiBaseURL + 'content/' + contentId + '/' + item.icon?.src
                            : item.icon?.src}"
                        alt="{item.text}"
                    /></span
                >
            {/if}
            <div><span>{item.number}</span><wbr />{item.text}</div>
        {/if}
    </div>
{/each}
